const actions = {
  data: () => ({
    chooseDialogVal: false
  }),

  methods: {
    toggleCat (cat) {
      // this.$store.dispatch('saveAction', { page: 3, type: 2, item: cat.id })
      this.$store.dispatch('saveMixed', { page: 3, type: 2, data: { catalog: this.catalog, id: cat.id }, ignoreResponseBar: false })
    },
    deleteCat (cat) {
      this.$store.dispatch('setOverlay', true)
      if (cat.children && cat.children.length > 0) {
        this.chooseDialogVal = true
      } else {
        this.$root.$dialog.confirm({
          text: `${this.lang.categories.dialog.deleteConfirm} ${cat.name}?`,
          title: this.lang.confirm.title,
          waitForResult: true
        }).then(res => {
          this.$store.dispatch('setOverlay', false)
          // if (res) this.$store.dispatch('saveAction', { page: 3, type: 1, item: cat.id })
          if (res) this.$store.dispatch('saveMixed', { page: 3, type: 1, data: { catalog: this.catalog, id: cat.id }, ignoreResponseBar: false })
        })
      }
    },
    chooseDialogClosed (newValue) {
      this.chooseDialogVal = !newValue
      this.$store.dispatch('setOverlay', !newValue)
    },
    chooseDialogReply ({ cat, reply }) {
      if (reply === 1) {
        // this.$store.dispatch('saveAction', { page: 3, type: 3, item: cat.id })
        this.$store.dispatch('saveMixed', { page: 3, type: 3, data: { catalog: this.catalog, id: cat.id }, ignoreResponseBar: false })
      } else if (reply === 2) {
        // this.$store.dispatch('saveAction', { page: 3, type: 1, item: cat.id })
        this.$store.dispatch('saveMixed', { page: 3, type: 1, data: { catalog: this.catalog, id: cat.id }, ignoreResponseBar: false })
      }
    }
  }
}
export default actions
